<script>
	import InfoPage from './InfoPage.svelte';
	import InfoSection from './InfoSection.svelte';
	import { Icon } from '../feathericons.js';

</script>

<InfoPage Title="Harston">

<svelte:fragment slot="blurb">
<InfoSection src="pics/harston.jpg" alt="Harston">
<p>Harston is a small village on the way to Cambridge. The main reason to visit is the recreation area or the rec. Harston is home to The Queens Head, a pub / restaurant that does Thai style meals. It is also home to BrewBoard, a small trendy brewery that often puts on events with music and food trucks.</p>
<p><a href="http://www.harstonvillage.uk/local-facilities/" target="new">{@html Icon("external-link","small")} Harston website</a></p>
</InfoSection>
</svelte:fragment>

<svelte:fragment slot="playgrounds">
<InfoSection id="harston_rec" Title="Harston Rec" src="pics/harston-rec.jpg" alt="Harston Rec Park">
<p>
Harston Rec features a nice park with little and big kid areas, a football field, and an orchard. This makes it a nice place to come as you can go for a little walk and then exercise the little monsters at the park. You can access further walks from the orchard.
</p>
</InfoSection>
</svelte:fragment>
</InfoPage>
